export const setSequenceNumbers = (object, prefix) => {
  object.forEach((child, i) => {
    const seq = `${prefix ? prefix + '.' + (i + 1) : i + 1}`;

    child.seqNumber = seq;
    if (child.hasOwnProperty('children'))
      setSequenceNumbers(child.children, seq);
  });
  return object;
};

export const flattenFileStructure = tree =>
  tree
    ? tree.reduce(
        (result, item) => [
          ...result,
          item,
          ...flattenFileStructure(item.children),
        ],
        []
      )
    : [];
